
import { Suspense, lazy, useEffect, useState } from 'react';
import ModernHeroSection from '@/components/home/ModernHeroSection';
import { Skeleton } from '@/components/ui/skeleton';
import SEOHead from '@/components/SEOHead';
const SocialProofNotifications = lazy(() => import('@/components/SocialProofNotifications').then(m => ({ default: m.SocialProofNotifications })));

// Lazy load sections for better mobile performance
const FeaturedFirmsSection = lazy(() => import('@/components/home/FeaturedFirmsSection'));
const BestDealsSection = lazy(() => import('@/components/home/BestDealsSection'));
const TraderJournalSection = lazy(() => import('@/components/home/TraderJournalSection'));
const HowItWorks = lazy(() => import('@/components/HowItWorks'));
const FinalCtaSection = lazy(() => import('@/components/home/FinalCtaSection'));

const Index = () => {
  const homePageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Verify Prop - Compare & Review the Best Prop Trading Firms | VerifyProp",
    "description": "Verify prop trading firms with real trader reviews and comparisons. VerifyProp helps you compare verified prop trading firms and find exclusive deals.",
    "url": "https://verifyprop.com/",
    "mainEntity": {
      "@type": "Organization",
      "name": "VerifyProp",
      "alternateName": "Verify Prop",
      "url": "https://verifyprop.com",
      "description": "Leading platform for verifying and comparing prop trading firms with real trader reviews"
    }
  };

  const [showSocialProof, setShowSocialProof] = useState(false);
  useEffect(() => {
    const start = () => setShowSocialProof(true);
    if ('requestIdleCallback' in window) {
      // @ts-ignore
      (window as any).requestIdleCallback(() => setTimeout(start, 3000));
    } else {
      setTimeout(start, 3000);
    }
  }, []);

  return (
    <div className="min-h-screen bg-dark-bg overflow-hidden">
      {showSocialProof && (
        <Suspense fallback={null}>
          <SocialProofNotifications />
        </Suspense>
      )}
      <SEOHead
        title="Verify Prop - Compare & Review the Best Prop Trading Firms | VerifyProp"
        description="Verify prop trading firms with real trader reviews and comparisons. VerifyProp helps you compare verified prop trading firms and find exclusive deals. Join thousands of traders."
        keywords="verify prop, verify prop firms, verifyprop, prop trading, prop firms, trading firms, forex trading, funded trading, prop trading reviews, trading challenges, proprietary trading, prop firm verification"
        canonical="https://verifyprop.com/"
        structuredData={homePageSchema}
      />
      <ModernHeroSection />
      <Suspense fallback={<Skeleton className="h-96 w-full max-w-7xl mx-auto my-12 rounded-2xl" />}>
        <FeaturedFirmsSection />
      </Suspense>
      <Suspense fallback={<Skeleton className="h-96 w-full max-w-7xl mx-auto my-12 rounded-2xl" />}>
        <BestDealsSection />
      </Suspense>
      <Suspense fallback={<Skeleton className="h-72 w-full max-w-7xl mx-auto my-12 rounded-2xl" />}>
        <TraderJournalSection />
      </Suspense>
      <Suspense fallback={<Skeleton className="h-72 w-full max-w-7xl mx-auto my-12 rounded-2xl" />}>
        <HowItWorks />
      </Suspense>
      <Suspense fallback={<Skeleton className="h-64 w-full max-w-7xl mx-auto my-12 rounded-2xl" />}>
        <FinalCtaSection />
      </Suspense>
    </div>
  );
};

export default Index;
